// extracted by mini-css-extract-plugin
export default {"layout":"layout___ajPtR","content":"content___PYp_s","aside":"aside___oHnct","asideHeader":"asideHeader___wyPAT","asideContent":"asideContent___K7hIr","you":"you___rF5n0"};